import _ from 'lodash'
import { useEffect, useState } from 'react'
import { Path, useWatch } from 'react-hook-form'

import {
  AbTestsCommonSchema,
  Variants,
  VariantsSchema,
} from 'features/ab-tests/forms/AbTestsCommonForm/abTestsCommonSchema'
import { VARIANTS_KEYS } from 'features/ab-tests/forms/AbTestsCommonForm/sections/constants'

export const useTrafficShare = () => {
  const variantPaths: Path<AbTestsCommonSchema>[] = VARIANTS_KEYS.map(
    (variantKey: keyof Variants): Path<AbTestsCommonSchema> =>
      `variants.${variantKey}.trafficShare` as Path<AbTestsCommonSchema>,
  )

  const variantShares = useWatch<AbTestsCommonSchema>({
    name: variantPaths,
  }) as VariantsSchema['trafficShare'][]

  const [totalShare, setTotalShare] = useState<number>(0)
  const isTotalShareValid: boolean = totalShare === 100

  useEffect(() => {
    if (variantShares.length > 0) {
      const filteredTrafficShares: number[] = variantShares.filter(
        (trafficShare: VariantsSchema['trafficShare']): trafficShare is number =>
          trafficShare !== undefined,
      )

      const totalTrafficShareSum = filteredTrafficShares.reduce(
        (accumulator: number, currentShare: number): number => accumulator + currentShare,
        0,
      )

      setTotalShare(_.round(totalTrafficShareSum, 2))
    }
  }, [variantShares])

  return {
    isTotalShareValid,
    totalShare,
  }
}
